<template>
  <!-- <div class="logo">
    <router-link :to="{name:'dashboard'}">
       <img src="@/assets/loginLogo.png" alt="logo" />
       <span>{{ global }}</span>
    </router-link>
  </div> -->
  <div id="logo" style="display: flex; align-items: center; justify-content: center; width: 80px" v-if="!showTitle">
    <img style="width: 50px; height: 50px" src="@/assets/loginLogo.png" alt="" />
  </div>
  <div id="logo" style="display: flex; align-items: center" v-else>
    <img style="width: 50px; height: 50px; margin-left: 10px" src="@/assets/loginLogo.png" alt="" />
    <span style="font-weight: 600; color: black; font-size: 18px; padding: 0 5px 0 5px; width: 150px">{{
      global
    }}</span>
  </div>
</template>

<script>
// import LogoSvg from '@/assets/logo.svg?inline'

export default {
  name: 'Logo',
  // components: {
  //   LogoSvg
  // },
  props: {
    title: {
      type: String,
      default: 'INX Cloud',
      required: false,
    },
    showTitle: {
      type: Boolean,
      default: true,
      required: false,
    },
  },
  computed: {
    global: () => process.env.VUE_APP_GLOBAL_NAME,
  },
}
</script>
